// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30jRs","left":"styles_left__cj1Ax"};